<script>
export default {
  name: 'specView',
  props: {
    list: {
      type: Array,
      default () {
        return []
      }
    }
  },
  data () {
  },
  created () {
  },
  methods: {
  }
}
</script>

<template>
  <div class="spec-body">
     <div v-for="specItem in list" class="spec-item">
       <div class="spec-item-title">
        <span>{{specItem.name}}:</span>
       </div>
       <div class="spec-item-content">
         <div v-for="valueItem in specItem.values" class="spec-value-item">
            <el-image style="width: 20px;height: 20px;border-radius: 5px;margin-right: 4px" :src="valueItem.thumbnail" :preview-src-list="[valueItem.thumbnail]">
            </el-image>
            <span> {{valueItem.valueName}}</span>
         </div>
       </div>
     </div>
  </div>
</template>

<style scoped>
.spec-body {

  color: #666;
}
.spec-item {
  display: flex;
  align-items: center;
}
.spec-item-title {
  white-space: nowrap;
  min-width: 40px;
}
.spec-item-content {
  display: flex;
  flex-wrap: wrap;
}
.spec-value-item {
  display: flex;
  align-items: center;
  background-color: #f5f5f5;
  padding: 5px;
  border-radius: 5px;
  margin-right: 10px;
  margin-bottom: 10px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

</style>
